export const designationUpdateAcitivityTypeConstants = [
  { name: "Terminate", value: "terminated" },
  { name: "Promotion", value: "promoted" },
  { name: "Demotion", value: "demoted" },
  { name: "Contract Ended", value: "contact_ended" },
];
